import { useTranslation } from '@aimsos/i18n';
import { SelectableChip, Skeleton } from '@aimsos/ui';

/**
 * Prototype inbox chips: All + Critical only (aims-htl wq-inbox-crit-chips).
 *
 * `totalCount`/`criticalCount` read from the in-scope event list, which starts
 * empty until the fan-out resolves — without a loading state these chips
 * flash "All 0 · Critical 0" for the same window the card list itself shows
 * {@link InboxListSkeleton}. `loading` swaps both chips for size-`m`-matched
 * skeleton pills so nothing pops from 0 to the real count once data lands.
 */
function InboxCritChips({ totalCount, criticalCount, criticalOnly, onChange, loading = false }) {
  const { t } = useTranslation('work-queues-app');

  if (loading) {
    return (
      <div className="flex flex-wrap items-center gap-2 px-1" aria-busy="true" aria-live="polite">
        <Skeleton width={64} height={28} borderRadius={9999} />
        <Skeleton width={84} height={28} borderRadius={9999} />
      </div>
    );
  }

  return (
    <div className="flex flex-wrap items-center gap-2 px-1">
      <SelectableChip size="m" selected={!criticalOnly} onClick={() => onChange(false)}>
        {t('views.allCount', { count: totalCount })}
      </SelectableChip>
      <SelectableChip
        size="m"
        selected={criticalOnly}
        onClick={() => onChange(true)}
        className={[
          '!border-rose-500 focus-visible:!border-rose-400',
          criticalOnly ? '!border-rose-500 !bg-rose-500 hover:!bg-rose-600' : '',
        ]
          .filter(Boolean)
          .join(' ')}
      >
        {t('views.criticalCount', { count: criticalCount })}
      </SelectableChip>
    </div>
  );
}

export default InboxCritChips;
